import { render, staticRenderFns } from "./recipient-element-popup.vue?vue&type=template&id=371787ed&"
import script from "./recipient-element-popup.vue?vue&type=script&lang=js&"
export * from "./recipient-element-popup.vue?vue&type=script&lang=js&"
import style0 from "./recipient-element-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports